import * as React from 'react'

import * as api from '@owl-nest/api-client/latest'

import * as events from './Events'
import { EventProps } from './type'

export function Event({ event }: EventProps): React.ReactElement<EventProps> {
  switch (event.type) {
    case api.EventType.PROJECT_START: {
      return <events.ProjectStart event={event} />
    }
    case api.EventType.PROJECT_END: {
      return <events.ProjectEnd event={event} />
    }
    case api.EventType.PROJECT_END_EXTRATIME: {
      return <events.ProjectEndExtratime event={event} />
    }
    case api.EventType.PERCENT_RAISED: {
      if (event.data.percent === 100) {
        return <events.GoalMet event={event} />
      }
      return <events.PercentRaised event={event} />
    }
    case api.EventType.FIRST_ORDER: {
      return <events.FirstOrder event={event} />
    }
    case api.EventType.SPONSORSHIP: {
      return <events.Sponsorship event={event} />
    }
  }
}
